import React, { JSX, useCallback } from 'react'
import i18n from 'live/services/i18n'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { KPISDrillingRegistryContextType } from '../../types/kpis-drilling/kpis-drilling-registry-type'
import { Section } from '../styles/common'

export const ReprocessRigFloorStatusComponent = (props: KPISDrillingRegistryContextType): JSX.Element => {
    const { isRigFloorReprocessing, isRigFloorWaiting } = props?.contextState?.reprocess?.rigfloor || {} // maybe it not exist in a first time

    const getRigFloorStatusComponent = useCallback((): JSX.Element => {
        if (isRigFloorWaiting) {
            return (
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip style={{ zIndex: 9999 }} id={'status-tooltip'}>
                            {i18n('Waiting for performance reprocessing')}
                        </Tooltip>
                    }
                >
                    <div
                        className="realtime-running-status"
                        style={{ width: 'fit-content', cursor: 'default', color: 'var(--gray-800)' }}
                    >
                        <i className="fa fa-spinner fa-spin" style={{ color: 'var(--gray-700)', marginRight: '4px' }} />
                        {i18n('Waiting')}
                    </div>
                </OverlayTrigger>
            )
        }

        if (isRigFloorReprocessing) {
            return (
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip style={{ zIndex: 9999 }} id={'status-tooltip'}>
                            {i18n('Reprocessing Rig Floor KPI data.')}
                        </Tooltip>
                    }
                >
                    <div
                        className="realtime-running-status"
                        style={{ width: 'fit-content', cursor: 'default', color: 'var(--gray-800)' }}
                    >
                        <i className="fa fa-wave-sine" style={{ color: 'var(--green-700)', marginRight: '4px' }} />
                        {i18n('Running')}
                    </div>
                </OverlayTrigger>
            )
        }

        return (
            <OverlayTrigger
                placement="top"
                overlay={
                    <Tooltip style={{ zIndex: 9999 }} id={'status-tooltip'}>
                        {i18n('No Rig Floor KPI data being reprocessed.')}
                    </Tooltip>
                }
            >
                <div
                    className="realtime-no-process-status"
                    style={{ width: 'fit-content', cursor: 'default', color: 'var(--gray-800)' }}
                >
                    <i className="far fa-empty-set" style={{ color: 'var(--gray-500)', marginRight: '4px' }}></i>
                    {i18n('No Reprocess')}
                </div>
            </OverlayTrigger>
        )
    }, [isRigFloorReprocessing, isRigFloorWaiting])

    return (
        <Section>
            <div className="section-name">
                <span>{i18n('Rig Floor Status')}</span>
            </div>
            <div className="section-status">{getRigFloorStatusComponent()}</div>
        </Section>
    )
}
